(()=>{
  // 03/11/2026 (Diego, como na Petgraf): o menu "Papelaria médica" do cabeçalho abre ao passar o mouse e fecha
  // 140 ms depois que o mouse sai (desktop, ponteiro fino). Clique e teclado continuam funcionando.
  const menus=[...document.querySelectorAll('.pg-desktop-nav .pg-materials-menu')];
  if(!menus.length)return;
  const fine=matchMedia('(hover: hover) and (pointer: fine)'),wide=matchMedia('(min-width: 1024px)');
  menus.forEach(menu=>{
    let timer=0;
    menu.addEventListener('pointerenter',e=>{if(e.pointerType!=='mouse'||!fine.matches||!wide.matches)return;clearTimeout(timer);menus.forEach(other=>{if(other!==menu)other.open=false;});menu.open=true;});
    menu.addEventListener('pointerleave',e=>{if(e.pointerType!=='mouse'||!fine.matches)return;clearTimeout(timer);timer=setTimeout(()=>{menu.open=false;},140);});
  });
})();
